import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useWs } from "@/context/WorkspaceContext";
import { useNavigate } from "react-router-dom";
import { Ticket, FolderKanban, AlertTriangle, Table2, ListChecks } from "lucide-react";

const STAT = {
  tasks: { label: "Tasks", icon: ListChecks, path: "inbox", key: "tasks", module: "inbox" },
  leads: { label: "Leads", icon: Table2, path: "leads", key: "leads", module: "leads" },
  reports: { label: "Reports", icon: FolderKanban, path: "reports", key: "reports", module: "reports" },
  tickets: { label: "Open Tickets", icon: Ticket, path: "tickets", key: "tickets_active", module: "tickets" },
};
const STAT_ORDER = ["tasks", "leads", "reports", "tickets"];

export default function Dashboard() {
  const { user, slug, visibleModules } = useWs();
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/dashboard").then((r) => setData(r.data)); }, []);

  const stats = STAT_ORDER.map((k) => STAT[k]).filter((s) => visibleModules.includes(s.module));

  return (
    <div>
      {/* Hero banner */}
      <div className="relative overflow-hidden rounded-3xl hero-gradient border border-[#f0f0f3] p-8 md:p-11 mb-8 animate-fade-up">
        <div className="absolute -top-16 -right-10 h-64 w-64 rounded-full bg-[#DDFD6C]/40 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-20 right-24 h-56 w-56 rounded-full bg-[#723FFF]/15 blur-3xl pointer-events-none" />
        <div className="relative max-w-xl">
          <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-[#06060C] leading-tight">
            Welcome back, {user.name.split(" ")[0]}
          </h1>
          <p className="mt-3 text-[15px] text-[#595D62] leading-relaxed max-w-md">
            Here's the latest across your Mission Control workspace - everything your team is working on, in one place.
          </p>
        </div>
      </div>

      {stats.length > 0 && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-8 stagger">
          {stats.map((s) => (
            <button key={s.path} data-testid={`dashboard-stat-${s.path}`} onClick={() => navigate(`/${slug}/${s.path}`)} className="text-left premium-card premium-card-hover p-6">
              <div className="h-10 w-10 rounded-2xl bg-[#F6F6FD] flex items-center justify-center text-[#723FFF] mb-5"><s.icon className="h-5 w-5" /></div>
              <p className="font-display text-4xl font-semibold text-[#06060C] tracking-tight">{data ? data[s.key] : "-"}</p>
              <p className="font-mono-data text-[10px] uppercase tracking-wider text-[#9FA1A4] mt-1.5">{s.label}</p>
            </button>
          ))}
        </div>
      )}

      {data?.tickets_overdue > 0 && (
        <div className="mb-8 flex items-center gap-3 rounded-2xl border border-[#F95B5F]/25 bg-[#F95B5F]/8 px-5 py-4">
          <AlertTriangle className="h-5 w-5 text-[#d83a3f]" />
          <p className="text-sm text-[#595D62]"><span className="font-semibold text-[#d83a3f]">{data.tickets_overdue}</span> ticket(s) awaiting information.</p>
        </div>
      )}
    </div>
  );
}
